import { render, staticRenderFns } from "./RemerciementDon.vue?vue&type=template&id=7152d2b6"
import script from "./RemerciementDon.vue?vue&type=script&lang=js"
export * from "./RemerciementDon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports